import comp from "./LeafNode";
export default comp;
